import React, { Component } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import DailyMaterialReportInfoSection from "../../../../libraries/ReportGenerator/DailyMaterialReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SignatureImage } from "../../utils/SignatureImage";
import { SFRTA_DailyMaterialUsageReportSchema } from "./SFRTA_DailyMaterialUsageReportSchema";
import ReportInlineInfoSection from "../../../../libraries/ReportGenerator/ReportInlineInfoSection";
import { ReportTitleInfoInlineWhiteSpace } from "../../../../libraries/ReportGenerator/ReportInlineInfoSection";
import { languageService } from "../../../../Language/language.service";
import { versionInfo } from "../../../MainPage/VersionInfo";
const normalize = (str) => {
  try {
    return JSON.parse(`"${str}"`);
  } catch (err) {
    return str;
  }
};
const materialTypesFormatter = (data, materialTypes, afeNumber, chargeCode) => {
  let tableType = "default";
  let check = true;
  let updatedBloc = [];
  updatedBloc =
    data &&
    data.bloc &&
    data.bloc.length > 0 &&
    data.bloc.map((obj) => {
      let attributesToAdd = {};
      let material = materialTypes.find((m) => m.description === normalize(obj.mate));

      if (material) {
        if (check) {
          tableType = "unit";
        }

        material &&
          material.opt1 &&
          material.opt1 &&
          material.opt1.attributes.forEach((attr) => {
            attributesToAdd[attr.key] = attr.value;
            if (check) {
              if (attr.key === "Item No") {
                tableType = "item";
              }

              check = false;
            }
          });
      }

      return {
        ...obj,
        ...attributesToAdd,
        afeNumber: afeNumber,
        chargeCode: chargeCode,
      };
    });

  data.bloc = updatedBloc;
  data["tableType"] = tableType;
};
const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { user, date, formSummary, isMaintenance, afeNumber, chargeCode } = reportData;
  if (!formSummary) formSummary = {};

  let data = {
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let milepostData = "";

  if (data.mpost) {
    milepostData = data.mpost;
  } else {
    if (data.mpStartMarker && data.mpEndMarker) {
      let check = data.mpStartMarker === "(N/A)" && data.mpEndMarker === "(N/A)";
      if (!check) milepostData = data.mpStartMarker + " - " + data.mpEndMarker;
    } else {
      if (data.mpStart && data.mpEnd) {
        milepostData = data.mpStart + " - " + data.mpEnd;
      } else if (data.mpStart && data.mpStart === data.mpEnd) {
        milepostData = data.mpStart;
      } else if (data.mpStart || data.mpEnd) {
        milepostData = data.mpStart ? data.mpStart : data.mpEnd;
      }
    }
  }

  let reportTitle = reportData.isMaintenance ? "MR Number" : "Title";
  let formValue = reportData.isMaintenance
    ? reportData.formSummary && reportData.formSummary.formId
      ? reportData.formSummary.formId
      : null
    : "N/A";

  materialTypesFormatter(data, props.materialTypes, afeNumber, chargeCode);

  let showTable = data && data.mused && data.mused === "No" ? false : true;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Daily Material Usage Report" {...props} centerTitle={true} isMaintenance={isMaintenance} />
      <ReportInfoSection
        fontSizeOverride={"20px"}
        rows={[
          {
            col1: {
              title: reportTitle,
              value: reportData.title,
            },
            col2: {
              title: "Form ID",
              value: formValue,
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: reportData.user.name,
            },
            col2: {
              title: "Date",
              value: data.reportDate,
            },
          },

          {
            col1: {
              title: "Start Time",
              value: dataFormatters.convert24HourFormattedTimeToAMPM(data.stime),
            },
            col2: {
              title: "End Time",
              value: dataFormatters.convert24HourFormattedTimeToAMPM(data.etime),
            },
          },

          {
            col1: {
              title: "Mile Post",
              value: milepostData,
            },
            col2: {
              title: "Task",
              value: data.task,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered" style={{ fontSize: "20px", position: "relative" }}>
        {SFRTA_DailyMaterialUsageReportSchema(data.tableType, versionInfo.isChargeCodeField()).sections.map((section) => {
          return (
            <React.Fragment key={section.name}>
              <ReportTableSectionRenderer section={section} rowsData={showTable ? data.bloc : []} />
            </React.Fragment>
          );
        })}
        {!showTable && (
          <div
            style={{
              position: "absolute",
              top: "48%",
              bottom: "auto",
              left: "50%",
              right: "auto",
              width: "fit-content",
              height: "fit-content",
              padding: "20px",
              fontSize: "50px",
              fontWeight: 600,
              transform: "translate(-50%, -50%)",
              color: "#b3b0b0",
              textTransform: "capitalize",
            }}
          >
            {languageService("No Material Used")}
          </div>
        )}
      </table>
    </div>
  );
};

const SFRTA_DailyMaterialUsageReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;

  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["sfrta_m_dailyMaterialUsageForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["sfrta_i_dailyMaterialUsageForm"]);

  return formSummaries.map((summary) => {
    return (
      <ReportView
        {...props}
        reportData={{
          formSummary: summary,
          date: ReportGeneratorUtils.getInspectionDate(inspec),
          user: ReportGeneratorUtils.getInspectionUser(inspec),
          afeNumber: ReportGeneratorUtils.getMaintenanceAfeNumber(inspec),
          chargeCode: ReportGeneratorUtils.getMaintenanceChargeCode(inspec),
          isMaintenance: isMaintenance,
          title: title,
        }}
      />
    );
  });
};

export default SFRTA_DailyMaterialUsageReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/DailyMaterialUsageReport/index.jsx